import React from 'react'
import styled from "styled-components";
import { Link } from "react-router-dom";
import LogoImg from '@/assets/imgs/logo.png'

export default function Logo() {
  return (
    <StyledLogo to="/">
      <img className='logo' src={LogoImg} alt="" />
    </StyledLogo>
  )
}

const StyledLogo = styled(Link)`
  align-items: center;
  display: flex;
  justify-content: center;  
  .logo{
    width: 144px;
  }
`;
